import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect, useMemo } from "react";
import Heading from "../heading/Heading";
import { Image, RichText } from "@sitecore-jss/sitecore-jss-react";
import { FormGroup } from "react-bootstrap";
import { Loading } from "../state/Loading";
import Wrapper from "../wrapper/Wrapper";
import { Counter } from "./Counter";
import { Button, Form, Accordion } from "react-bootstrap";
import { Customization } from "./Customization";
import { DividedContainer } from "./DividedContainer";
import { HandleSides } from "./HandleSides";
import * as UTIL from "../../util";
import MetaTags from 'react-meta-tags'; //ga tracker

import gaTracker from '../../util/ga-analytics/gaTracker';
import { ecommAdd, ecommEdit, ecommDetail } from "../../util";
import StickyCta from "./StickyCta";
import uniqueId from 'lodash.uniqueid';
import CustomizationAddOn from "./CustomizationAddOn";
var allSides = [];
var childSideOptions = [];

var addToOrderClick = function addToOrderClick() {
  var data = {
    gtm: {
      uniqueEventId: '33',
      elementId: "detail-addtoorder"
    },
    event: 'gtm.click'
  };
  gaTracker(data);
};

export var DetailWrapper = function DetailWrapper(props) {
  var _detail$Modifiers;

  var menuDetail = props.menuDetail,
      recieveError = props.recieveError;

  var _useState = useState({
    isLoading: true
  }),
      _useState2 = _slicedToArray(_useState, 2),
      detail = _useState2[0],
      setDetail = _useState2[1];

  var getLastPath = function getLastPath() {
    try {
      // const location = new URL('https://crackerbarrel.dev.local/menu/breakfast-all-day/pancakes-n-such/grandma-s-sampler?productid=9213618');
      var search = location.search.substring(1);
      var paramJSON = JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) {
        return key === "" ? value : decodeURIComponent(value);
      });
      return Boolean(paramJSON.productid) ? paramJSON.productid : window.location.hash.substr(1);
    } catch (_unused) {
      return window.location.hash.substr(1);
    }
  };

  var populateDetail = function populateDetail() {
    var detailId = getLastPath();
    var firstPath = window.location.pathname.split("/")[1] || "menu";

    if (UTIL.mobileAppUtil.isMobileApp() && !detailId) {
      //  console.log('MOBILE SKIPPING', window.location)
      // TODO :: NEED TO RESEARCH WHY MOBILE RENDER THIS ON A NON DETAIL PAGE ROUTE
      return;
    } //If no detail found throw error


    if (!detailId) {
      var error = {
        response: {
          data: {
            results: {
              code: "cb7502"
            }
          }
        }
      };
      recieveError(UTIL.buildError(error));
    }

    return UTIL.apiUtil.fetchGet("".concat(UTIL.apiUtil.API.getProduct, "/").concat(detailId, "?catalog=").concat(firstPath)).then(function (json) {
      var detail = createDetail(json);
      return setDetail(detail);
    }) // .catch(() => {
    //   const json = {"Details":{"CatalogName":"CB_Food_Store","SitecoreId":"6c92b3c1-e92c-25a1-a1bd-c9f971e3e894","ProductChainId":"174558","StoreProductId":"9213618","Category":null,"DisplayName":"Grandma's Sampler","ParentName":null,"ShortDescription":"Two Pancakes, two eggs* and a sampling of Bacon, Sausage and Ham. Served with choice of Breakfast Side plus 100% Pure Natural Syrup.","Description":"Two Buttermilk Pancakes n’ butter served with two eggs* and a sampling of Thick-Sliced Bacon, Smoked Sausage and Sugar Cured or Country Ham. Served with choice of Breakfast Side and 100% Pure Natural Syrup.\r\n\r\n\r\n","Brand":"","Tags":"","ServingSize":"","LighterFare":false,"ShowCaloriePerServing":false,"AdvanceNoticeTimeInHours":"0","CurrencySymbol":"USD","ListPrice":0.0000,"AdjustedPrice":null,"BaseCalories":"860","MaxCalories":"0","ImageFilePath":"https://olo-images-live.imgix.net/5c/5c379c161586461099e641ba735b90db.jpg?auto=format%2Ccompress&q=60&cs=tinysrgb&w=528&h=352&fit=fill&fm=png32&bg=transparent&s=1c77f5754e0fde039c49e718c3fba502","HighResImageFilePath":"https://olo-images-live.imgix.net/5c/5c379c161586461099e641ba735b90db.jpg?auto=format%2Ccompress&q=60&cs=tinysrgb&w=1200&h=800&fit=fill&fm=png32&bg=transparent&s=9ac08b742e7af9422f08bf6f2b46c0b0","MinimumQuantity":"1","MaximumQuantity":"0","MinimumBasketQuantity":"0","MaximumBasketQuantity":"0","DetailLink":"/menu/breakfast-all-day/pancakes-n-such/grandma-s-sampler?productid=9213618","Availability":null,"IsSpecialInstructonsEnabled":false,"CanPickup":false,"CanDeliver":true,"SortOrder":0,"OptionsExists":false,"IsFavourite":false,"IsRetail":false,"IsEat":false,"IsCater":false,"DefaultOptions":null,"Modifiers":null,"LeadTimeInfo":""},"MetaData":{"MetaTitle":"Grandma's Sampler","MetaKeywords":"","MetaDescription":"Two Buttermilk Pancakes n’ butter served with two eggs* and a sampling of Thick-Sliced Bacon, Smoked Sausage and Sugar Cured or Country Ham. Served with choice of Breakfast Side and 100% Pure Natural Syrup.\r\n\r\n\r\n"},"Modifiers":{"productModifiers":[{"optionGroupId":329092165,"chainId":258649,"description":"Meat Choice","mandatory":true,"supportsChoiceQuantities":false,"choiceQuantityIncrement":1,"explanationText":null,"sortOrder":1,"productModifierOptionMetaDatas":[{"id":426100,"optionGroupId":329092165,"metaKey":"mobile-display-name","metaValue":"Meat"}],"productModifierOptions":[{"optionId":1685375187,"optionGroupId":329092165,"chainId":1285180,"optionName":"Country Ham","optionImagePath":"/-/jssmedia/Project/cb-brandsite/brandsite/menu/options/country-ham.jpg","isDefault":false,"cost":10.4900,"adjustsParentCalories":true,"adjustsParentPrice":true,"sortOrder":0,"parentOptionId":0,"basecalories":140.00000,"productModifierOptionsGroup":[],"isSelected":false},{"optionId":1685375188,"optionGroupId":329092165,"chainId":1285181,"optionName":"Sugar Ham","optionImagePath":"/-/jssmedia/Project/cb-brandsite/brandsite/menu/options/sugar-ham.jpg","isDefault":false,"cost":10.4900,"adjustsParentCalories":true,"adjustsParentPrice":true,"sortOrder":1,"parentOptionId":0,"basecalories":90.00000,"productModifierOptionsGroup":[],"isSelected":false}]},{"optionGroupId":329092166,"chainId":258650,"description":"Topping Choice","mandatory":true,"supportsChoiceQuantities":false,"choiceQuantityIncrement":1,"explanationText":null,"sortOrder":2,"productModifierOptionMetaDatas":[{"id":426388,"optionGroupId":329092166,"metaKey":"mobile-display-name","metaValue":"Topping"}],"productModifierOptions":[{"optionId":1685375191,"optionGroupId":329092166,"chainId":1285184,"optionName":"100% Pure Natural Syrup","optionImagePath":"/-/jssmedia/Project/cb-brandsite/brandsite/menu/options/100--pure-natural-syrup.jpg","isDefault":false,"cost":0.0000,"adjustsParentCalories":true,"adjustsParentPrice":false,"sortOrder":0,"parentOptionId":0,"basecalories":150.00000,"productModifierOptionsGroup":[],"isSelected":false},{"optionId":1685375190,"optionGroupId":329092166,"chainId":1285183,"optionName":"Peach","optionImagePath":"/-/jssmedia/Project/cb-brandsite/brandsite/menu/options/peach.jpg","isDefault":false,"cost":0.0000,"adjustsParentCalories":true,"adjustsParentPrice":false,"sortOrder":1,"parentOptionId":0,"basecalories":320.00000,"productModifierOptionsGroup":[],"isSelected":false},{"optionId":1685375192,"optionGroupId":329092166,"chainId":1285185,"optionName":"Apple","optionImagePath":"/-/jssmedia/Project/cb-brandsite/brandsite/menu/options/apple.jpg","isDefault":false,"cost":0.0000,"adjustsParentCalories":true,"adjustsParentPrice":false,"sortOrder":2,"parentOptionId":0,"basecalories":390.00000,"productModifierOptionsGroup":[],"isSelected":false},{"optionId":2129628325,"optionGroupId":329092166,"chainId":1337562,"optionName":"Sugar Free Maple Syrup","optionImagePath":"/-/jssmedia/Project/cb-brandsite/brandsite/menu/options/sugar-free-maple-syrup.jpg","isDefault":false,"cost":0.0000,"adjustsParentCalories":true,"adjustsParentPrice":false,"sortOrder":3,"parentOptionId":0,"basecalories":15.00000,"productModifierOptionsGroup":[],"isSelected":false},{"optionId":7748155740,"optionGroupId":329092166,"chainId":5203141,"optionName":"Strawberry Syrup","optionImagePath":"/-/jssmedia/Project/cb-brandsite/brandsite/menu/options/strawberry-syrup.jpg","isDefault":false,"cost":0.0000,"adjustsParentCalories":false,"adjustsParentPrice":false,"sortOrder":4,"parentOptionId":0,"basecalories":0.00000,"productModifierOptionsGroup":[],"isSelected":false}]},{"optionGroupId":1818581660,"chainId":1052749,"description":"Add a Topping?","mandatory":false,"supportsChoiceQuantities":false,"choiceQuantityIncrement":1,"explanationText":null,"sortOrder":3,"productModifierOptionMetaDatas":[],"productModifierOptions":[{"optionId":8294668096,"optionGroupId":1818581660,"chainId":5228492,"optionName":"Fresh Strawberries","optionImagePath":"/-/jssmedia/Project/cb-brandsite/brandsite/menu/options/fresh-strawberries.jpg","isDefault":false,"cost":1.2900,"adjustsParentCalories":true,"adjustsParentPrice":true,"sortOrder":16,"parentOptionId":0,"basecalories":25.00000,"productModifierOptionsGroup":[],"isSelected":false},{"optionId":8294668095,"optionGroupId":1818581660,"chainId":5228490,"optionName":"Chocolate Whipped Topping","optionImagePath":"/-/jssmedia/Project/cb-brandsite/brandsite/menu/options/chocolate-whipped-topping.jpg","isDefault":false,"cost":0.5000,"adjustsParentCalories":true,"adjustsParentPrice":true,"sortOrder":17,"parentOptionId":0,"basecalories":50.00000,"productModifierOptionsGroup":[],"isSelected":false}]},{"optionGroupId":329092167,"chainId":252625,"description":"Egg Choice*","mandatory":true,"supportsChoiceQuantities":false,"choiceQuantityIncrement":1,"explanationText":null,"sortOrder":4,"productModifierOptionMetaDatas":[{"id":425992,"optionGroupId":329092167,"metaKey":"mobile-display-name","metaValue":"Eggs"}],"productModifierOptions":[{"optionId":1685375193,"optionGroupId":329092167,"chainId":1261282,"optionName":"Egg Whites","optionImagePath":"/-/jssmedia/Project/cb-brandsite/brandsite/menu/options/egg-whites.jpg","isDefault":false,"cost":0.0000,"adjustsParentCalories":true,"adjustsParentPrice":false,"sortOrder":0,"parentOptionId":0,"basecalories":-90.00000,"productModifierOptionsGroup":[{"optionGroupId":329092241,"chainId":252626,"description":"Cheese Choice","mandatory":false,"supportsChoiceQuantities":false,"choiceQuantityIncrement":1,"explanationText":null,"sortOrder":0,"productModifierOptionMetaDatas":[{"id":426088,"optionGroupId":329092241,"metaKey":"mobile-display-name","metaValue":"Cheese"}],"productModifierOptions":[{"optionId":1685375455,"optionGroupId":329092241,"chainId":1261294,"optionName":"Add Colby Cheese","optionImagePath":"/-/jssmedia/Project/cb-brandsite/brandsite/menu/options/add-colby-cheese.jpg","isDefault":false,"cost":1.2900,"adjustsParentCalories":true,"adjustsParentPrice":true,"sortOrder":0,"parentOptionId":1685375193,"basecalories":170.00000,"productModifierOptionsGroup":[],"isSelected":false}]}],"isSelected":false},{"optionId":1685375194,"optionGroupId":329092167,"chainId":1261283,"optionName":"Over Easy","optionImagePath":"/-/jssmedia/Project/cb-brandsite/brandsite/menu/options/over-easy.jpg","isDefault":false,"cost":0.0000,"adjustsParentCalories":false,"adjustsParentPrice":false,"sortOrder":1,"parentOptionId":0,"basecalories":0.00000,"productModifierOptionsGroup":[],"isSelected":false},{"optionId":1685375195,"optionGroupId":329092167,"chainId":1261284,"optionName":"Over Medium","optionImagePath":"/-/jssmedia/Project/cb-brandsite/brandsite/menu/options/over-medium.jpg","isDefault":false,"cost":0.0000,"adjustsParentCalories":false,"adjustsParentPrice":false,"sortOrder":2,"parentOptionId":0,"basecalories":0.00000,"productModifierOptionsGroup":[],"isSelected":false},{"optionId":1685375196,"optionGroupId":329092167,"chainId":1261286,"optionName":"Over Well","optionImagePath":"/-/jssmedia/Project/cb-brandsite/brandsite/menu/options/over-well.jpg","isDefault":false,"cost":0.0000,"adjustsParentCalories":false,"adjustsParentPrice":false,"sortOrder":3,"parentOptionId":0,"basecalories":0.00000,"productModifierOptionsGroup":[],"isSelected":false},{"optionId":1685375197,"optionGroupId":329092167,"chainId":1261288,"optionName":"Scrambled","optionImagePath":"/-/jssmedia/Project/cb-brandsite/brandsite/menu/options/scrambled.jpg","isDefault":false,"cost":0.0000,"adjustsParentCalories":false,"adjustsParentPrice":false,"sortOrder":4,"parentOptionId":0,"basecalories":0.00000,"productModifierOptionsGroup":[{"optionGroupId":329092242,"chainId":252626,"description":"Cheese Choice","mandatory":false,"supportsChoiceQuantities":false,"choiceQuantityIncrement":1,"explanationText":null,"sortOrder":0,"productModifierOptionMetaDatas":[{"id":426155,"optionGroupId":329092242,"metaKey":"mobile-display-name","metaValue":"Cheese"}],"productModifierOptions":[{"optionId":1685375456,"optionGroupId":329092242,"chainId":1261294,"optionName":"Add Colby Cheese","optionImagePath":"/-/jssmedia/Project/cb-brandsite/brandsite/menu/options/add-colby-cheese.jpg","isDefault":false,"cost":1.2900,"adjustsParentCalories":true,"adjustsParentPrice":true,"sortOrder":0,"parentOptionId":1685375197,"basecalories":170.00000,"productModifierOptionsGroup":[],"isSelected":false}]}],"isSelected":false},{"optionId":1685375198,"optionGroupId":329092167,"chainId":1261293,"optionName":"Sunny Side Up","optionImagePath":"/-/jssmedia/Project/cb-brandsite/brandsite/menu/options/sunny-side-up.jpg","isDefault":false,"cost":0.0000,"adjustsParentCalories":false,"adjustsParentPrice":false,"sortOrder":8,"parentOptionId":0,"basecalories":0.00000,"productModifierOptionsGroup":[],"isSelected":false}]},{"optionGroupId":1401931009,"chainId":252627,"description":"Side Choice","mandatory":true,"supportsChoiceQuantities":false,"choiceQuantityIncrement":1,"explanationText":null,"sortOrder":5,"productModifierOptionMetaDatas":[{"id":425436,"optionGroupId":1401931009,"metaKey":"mobile-display-name","metaValue":"Side"}],"productModifierOptions":[{"optionId":6369565064,"optionGroupId":1401931009,"chainId":1261295,"optionName":"Loaded Hashbrown Casserole","optionImagePath":"/-/jssmedia/Project/cb-brandsite/brandsite/menu/options/loaded-hashbrown-casserole.jpg","isDefault":false,"cost":1.6900,"adjustsParentCalories":true,"adjustsParentPrice":true,"sortOrder":1,"parentOptionId":0,"basecalories":350.00000,"productModifierOptionsGroup":[],"isSelected":false},{"optionId":6369565067,"optionGroupId":1401931009,"chainId":2083589,"optionName":"Plain Hashbrowns","optionImagePath":"/-/jssmedia/Project/cb-brandsite/brandsite/menu/options/plain-hashbrowns.jpg","isDefault":false,"cost":0.9900,"adjustsParentCalories":true,"adjustsParentPrice":true,"sortOrder":5,"parentOptionId":0,"basecalories":230.00000,"productModifierOptionsGroup":[],"isSelected":false},{"optionId":6369565065,"optionGroupId":1401931009,"chainId":1261297,"optionName":"Fried Apples","optionImagePath":"/-/jssmedia/Project/cb-brandsite/brandsite/menu/options/fried-apples.jpg","isDefault":false,"cost":0.0000,"adjustsParentCalories":true,"adjustsParentPrice":false,"sortOrder":6,"parentOptionId":0,"basecalories":170.00000,"productModifierOptionsGroup":[],"isSelected":false},{"optionId":6369565066,"optionGroupId":1401931009,"chainId":1261298,"optionName":"Hashbrown Casserole","optionImagePath":"/-/jssmedia/Project/cb-brandsite/brandsite/menu/options/hashbrown-casserole.jpg","isDefault":false,"cost":0.0000,"adjustsParentCalories":true,"adjustsParentPrice":false,"sortOrder":7,"parentOptionId":0,"basecalories":190.00000,"productModifierOptionsGroup":[],"isSelected":false},{"optionId":7818483316,"optionGroupId":1401931009,"chainId":4993475,"optionName":"Coarse Ground Grits","optionImagePath":"/-/jssmedia/Project/cb-brandsite/brandsite/menu/options/coarse-ground-grits.jpg","isDefault":false,"cost":0.0000,"adjustsParentCalories":true,"adjustsParentPrice":false,"sortOrder":8,"parentOptionId":0,"basecalories":150.00000,"productModifierOptionsGroup":[],"isSelected":false}]},{"optionGroupId":1663582237,"chainId":1015081,"description":"Add a Drink?","mandatory":true,"supportsChoiceQuantities":false,"choiceQuantityIncrement":1,"explanationText":null,"sortOrder":6,"productModifierOptionMetaDatas":[],"productModifierOptions":[{"optionId":7495788540,"optionGroupId":1663582237,"chainId":5034545,"optionName":"No Thank You","optionImagePath":"/-/jssmedia/Project/cb-brandsite/brandsite/menu/options/no-thank-you.jpg","isDefault":true,"cost":0.0000,"adjustsParentCalories":false,"adjustsParentPrice":false,"sortOrder":0,"parentOptionId":0,"basecalories":0.00000,"productModifierOptionsGroup":[],"isSelected":true},{"optionId":7495788528,"optionGroupId":1663582237,"chainId":5034515,"optionName":"Caramel Latte","optionImagePath":"/-/jssmedia/Project/cb-brandsite/brandsite/menu/options/caramel-latte.jpg","isDefault":false,"cost":3.4900,"adjustsParentCalories":true,"adjustsParentPrice":true,"sortOrder":3,"parentOptionId":0,"basecalories":250.00000,"productModifierOptionsGroup":[],"isSelected":false},{"optionId":7495788534,"optionGroupId":1663582237,"chainId":5034521,"optionName":"Iced Caramel Latte","optionImagePath":"/-/jssmedia/Project/cb-brandsite/brandsite/menu/options/iced-caramel-latte.jpg","isDefault":false,"cost":3.4900,"adjustsParentCalories":true,"adjustsParentPrice":true,"sortOrder":4,"parentOptionId":0,"basecalories":210.00000,"productModifierOptionsGroup":[],"isSelected":false},{"optionId":7495788526,"optionGroupId":1663582237,"chainId":5034513,"optionName":"Regular Coffee","optionImagePath":"/-/jssmedia/Project/cb-brandsite/brandsite/menu/options/regular-coffee.jpg","isDefault":false,"cost":2.9900,"adjustsParentCalories":true,"adjustsParentPrice":true,"sortOrder":5,"parentOptionId":0,"basecalories":0.00000,"productModifierOptionsGroup":[],"isSelected":false},{"optionId":7495788535,"optionGroupId":1663582237,"chainId":5034522,"optionName":"Decaf Coffee","optionImagePath":"/-/jssmedia/Project/cb-brandsite/brandsite/menu/options/decaf-coffee.jpg","isDefault":false,"cost":2.9900,"adjustsParentCalories":false,"adjustsParentPrice":true,"sortOrder":6,"parentOptionId":0,"basecalories":0.00000,"productModifierOptionsGroup":[],"isSelected":false},{"optionId":7495788529,"optionGroupId":1663582237,"chainId":5034516,"optionName":"Hot Chocolate","optionImagePath":"/-/jssmedia/Project/cb-brandsite/brandsite/menu/options/hot-chocolate.jpg","isDefault":false,"cost":3.4900,"adjustsParentCalories":true,"adjustsParentPrice":true,"sortOrder":7,"parentOptionId":0,"basecalories":380.00000,"productModifierOptionsGroup":[],"isSelected":false},{"optionId":7495788530,"optionGroupId":1663582237,"chainId":5034517,"optionName":"Orange Juice","optionImagePath":"/-/jssmedia/Project/cb-brandsite/brandsite/menu/options/orange-juice.jpg","isDefault":false,"cost":2.9900,"adjustsParentCalories":true,"adjustsParentPrice":true,"sortOrder":8,"parentOptionId":0,"basecalories":220.00000,"productModifierOptionsGroup":[],"isSelected":false},{"optionId":7495788531,"optionGroupId":1663582237,"chainId":5034518,"optionName":"2% Milk","optionImagePath":"/-/jssmedia/Project/cb-brandsite/brandsite/menu/options/2--milk.jpg","isDefault":false,"cost":2.9900,"adjustsParentCalories":true,"adjustsParentPrice":true,"sortOrder":9,"parentOptionId":0,"basecalories":260.00000,"productModifierOptionsGroup":[],"isSelected":false},{"optionId":7495788532,"optionGroupId":1663582237,"chainId":5034519,"optionName":"Coca-Cola","optionImagePath":"/-/jssmedia/Project/cb-brandsite/brandsite/menu/options/coca-cola.jpg","isDefault":false,"cost":2.9900,"adjustsParentCalories":true,"adjustsParentPrice":true,"sortOrder":10,"parentOptionId":0,"basecalories":190.00000,"productModifierOptionsGroup":[],"isSelected":false},{"optionId":7495788533,"optionGroupId":1663582237,"chainId":5034520,"optionName":"Diet Coke","optionImagePath":"/-/jssmedia/Project/cb-brandsite/brandsite/menu/options/diet-coke.jpg","isDefault":false,"cost":2.9900,"adjustsParentCalories":false,"adjustsParentPrice":true,"sortOrder":11,"parentOptionId":0,"basecalories":0.00000,"productModifierOptionsGroup":[],"isSelected":false},{"optionId":7495788536,"optionGroupId":1663582237,"chainId":5034523,"optionName":"Freshly Brewed Sweet Iced Tea","optionImagePath":"/-/jssmedia/Project/cb-brandsite/brandsite/menu/options/freshly-brewed-sweet-iced-tea.jpg","isDefault":false,"cost":2.9900,"adjustsParentCalories":true,"adjustsParentPrice":true,"sortOrder":12,"parentOptionId":0,"basecalories":130.00000,"productModifierOptionsGroup":[],"isSelected":false},{"optionId":7495788537,"optionGroupId":1663582237,"chainId":5034524,"optionName":"Freshly Brewed Unsweetened Iced Tea","optionImagePath":"/-/jssmedia/Project/cb-brandsite/brandsite/menu/options/freshly-brewed-unsweetened-iced-tea.jpg","isDefault":false,"cost":2.9900,"adjustsParentCalories":false,"adjustsParentPrice":true,"sortOrder":13,"parentOptionId":0,"basecalories":0.00000,"productModifierOptionsGroup":[],"isSelected":false},{"optionId":8244248128,"optionGroupId":1663582237,"chainId":5302249,"optionName":"Southern Half n' Half","optionImagePath":"/-/jssmedia/Project/cb-brandsite/brandsite/menu/options/southern-half-n--half.jpg","isDefault":false,"cost":3.1900,"adjustsParentCalories":true,"adjustsParentPrice":true,"sortOrder":14,"parentOptionId":0,"basecalories":200.00000,"productModifierOptionsGroup":[],"isSelected":false},{"optionId":8607595403,"optionGroupId":1663582237,"chainId":5056504,"optionName":"Blackberry Tea","optionImagePath":"/-/jssmedia/Project/cb-brandsite/brandsite/menu/options/blackberry-tea.jpg","isDefault":false,"cost":3.2900,"adjustsParentCalories":false,"adjustsParentPrice":true,"sortOrder":16,"parentOptionId":0,"basecalories":0.00000,"productModifierOptionsGroup":[],"isSelected":false},{"optionId":7495788539,"optionGroupId":1663582237,"chainId":5034526,"optionName":"Peach Tea","optionImagePath":"/-/jssmedia/Project/cb-brandsite/brandsite/menu/options/peach-tea.jpg","isDefault":false,"cost":3.2900,"adjustsParentCalories":true,"adjustsParentPrice":true,"sortOrder":17,"parentOptionId":0,"basecalories":240.00000,"productModifierOptionsGroup":[],"isSelected":false}]}]},"AddOnProductsData":null}
    //   const detail = createDetail({...json, AddOnProductsData: {
    //     "Header": "$5 take home",
    //     "Headline": "Choose any one $5 item",
    //     "AddOnProducts": [
    //         {
    //             "ProductChainId": "173268",
    //             "StoreProductId": "50902685",
    //             "Name": "173268",
    //             "DisplayName": "Coca-Cola®",
    //             "ShortDescription": "32 oz Coca-Cola.",
    //             "ImageUrl": "https://olo-images-live.imgix.net/4f/4fcdeaa34282417389f63b6035ba38a2.jpg?auto=format%2Ccompress&q=60&cs=tinysrgb&w=528&h=352&fit=fill&fm=png32&bg=transparent&s=90f97564f15a7ac5a9639bddf48afc9b",
    //             "ListPrice": 223,
    //             "CurrencySymbol": "USD",
    //             "Calories": 15
    //         },
    //         {
    //           "ProductChainId": "173264",
    //           "StoreProductId": "50902685",
    //           "Name": "173264",
    //           "DisplayName": "Coca-Cola®",
    //           "ShortDescription": "32 oz Coca-Cola.",
    //           "ImageUrl": "https://olo-images-live.imgix.net/4f/4fcdeaa34282417389f63b6035ba38a2.jpg?auto=format%2Ccompress&q=60&cs=tinysrgb&w=528&h=352&fit=fill&fm=png32&bg=transparent&s=90f97564f15a7ac5a9639bddf48afc9b",
    //           "ListPrice": 223,
    //           "CurrencySymbol": "USD",
    //           "Calories": 15
    //         },
    //         {
    //           "ProductChainId": "173266",
    //           "StoreProductId": "50902685",
    //           "Name": "173266",
    //           "DisplayName": "Coca-Cola®",
    //           "ShortDescription": "32 oz Coca-Cola.",
    //           "ImageUrl": "https://olo-images-live.imgix.net/4f/4fcdeaa34282417389f63b6035ba38a2.jpg?auto=format%2Ccompress&q=60&cs=tinysrgb&w=528&h=352&fit=fill&fm=png32&bg=transparent&s=90f97564f15a7ac5a9639bddf48afc9b",
    //           "ListPrice": 223,
    //           "CurrencySymbol": "USD",
    //           "Calories": 15
    //         },
    //         {
    //           "ProductChainId": "173267",
    //           "StoreProductId": "50902685",
    //           "Name": "173267",
    //           "DisplayName": "Coca-Cola®",
    //           "ShortDescription": "32 oz Coca-Cola.",
    //           "ImageUrl": "https://olo-images-live.imgix.net/4f/4fcdeaa34282417389f63b6035ba38a2.jpg?auto=format%2Ccompress&q=60&cs=tinysrgb&w=528&h=352&fit=fill&fm=png32&bg=transparent&s=90f97564f15a7ac5a9639bddf48afc9b",
    //           "ListPrice": 223,
    //           "CurrencySymbol": "USD",
    //           "Calories": 15
    //         },
    //         {
    //           "ProductChainId": "1732681",
    //           "StoreProductId": "50902685",
    //           "Name": "1732681",
    //           "DisplayName": "Coca-Cola®",
    //           "ShortDescription": "32 oz Coca-Cola.",
    //           "ImageUrl": "https://olo-images-live.imgix.net/4f/4fcdeaa34282417389f63b6035ba38a2.jpg?auto=format%2Ccompress&q=60&cs=tinysrgb&w=528&h=352&fit=fill&fm=png32&bg=transparent&s=90f97564f15a7ac5a9639bddf48afc9b",
    //           "ListPrice": 223,
    //           "CurrencySymbol": "USD",
    //           "Calories": 15
    //         },
    //         {
    //           "ProductChainId": "1732682",
    //           "StoreProductId": "50902685",
    //           "Name": "1732682",
    //           "DisplayName": "Coca-Cola®",
    //           "ShortDescription": "32 oz Coca-Cola.",
    //           "ImageUrl": "https://olo-images-live.imgix.net/4f/4fcdeaa34282417389f63b6035ba38a2.jpg?auto=format%2Ccompress&q=60&cs=tinysrgb&w=528&h=352&fit=fill&fm=png32&bg=transparent&s=90f97564f15a7ac5a9639bddf48afc9b",
    //           "ListPrice": 223,
    //           "CurrencySymbol": "USD",
    //           "Calories": 15
    //         }
    //     ]
    //   }})
    //   return setDetail(detail)
    // })
    .catch(function (err) {
      console.log(err, "err");
      var error = {
        response: {
          data: {
            results: {
              code: "cb7502"
            }
          }
        }
      };
      recieveError(UTIL.buildError(error));
    });
  };

  var createDetail = function createDetail(apiDetails) {
    var model;

    try {
      model = _objectSpread({
        image: {
          value: {
            src: apiDetails.HighResImageFilePath || apiDetails.ImageFilePath,
            alt: apiDetails.DisplayName
          }
        },
        title: {
          value: apiDetails.DisplayName
        },
        calories: {
          value: parseInt(apiDetails.BaseCalories) ? "".concat(apiDetails.BaseCalories).concat(apiDetails.MaxCalories === "0" ? "" : "-".concat(apiDetails.MaxCalories), " cal") : ""
        },
        desc: {
          value: apiDetails.Description
        },
        nutritional: {
          value: apiDetails.ShortDescription
        },
        initcost: {
          value: apiDetails.AdjustedPrice || apiDetails.ListPrice
        }
      }, apiDetails);
    } catch (e) {
      model = {
        isLoading: true
      };
    }

    return model;
  };

  useEffect(function () {
    if (Boolean(menuDetail)) {
      setDetail(menuDetail);
    } else {
      populateDetail();
    }
  }, []);
  var details = createDetail(detail === null || detail === void 0 ? void 0 : detail.Details);
  var modifications = detail === null || detail === void 0 ? void 0 : (_detail$Modifiers = detail.Modifiers) === null || _detail$Modifiers === void 0 ? void 0 : _detail$Modifiers.productModifiers;
  var metadata = detail === null || detail === void 0 ? void 0 : detail.MetaData;
  return /*#__PURE__*/React.createElement(Detail, _extends({
    details: details,
    modifications: modifications,
    addOn: detail.AddOnProductsData,
    metadata: metadata
  }, props));
};

var Detail = function Detail(props) {
  var _editCartItem$AddOnPr2, _addOn$AddOnProducts5;

  var details = props.details,
      _props$modifications = props.modifications,
      modifications = _props$modifications === void 0 ? [] : _props$modifications,
      _props$metadata = props.metadata,
      metadata = _props$metadata === void 0 ? {} : _props$metadata,
      layout = props.layout,
      _props$postItem = props.postItem,
      postItem = _props$postItem === void 0 ? function (data) {
    return "";
  } : _props$postItem,
      defaultOptions = props.defaultOptions,
      _props$editCartItem = props.editCartItem,
      editCartItem = _props$editCartItem === void 0 ? {} : _props$editCartItem,
      _props$updateCartLine = props.updateCartLine,
      updateCartLine = _props$updateCartLine === void 0 ? function () {
    return console.log("submittedupdateCartLine");
  } : _props$updateCartLine,
      _props$location = props.location,
      location = _props$location === void 0 ? {} : _props$location,
      _props$Disclaimer = props.Disclaimer,
      Disclaimer = _props$Disclaimer === void 0 ? {} : _props$Disclaimer,
      overrideOptions = props.overrideOptions,
      Overrides = props.Overrides,
      addTo = props.addTo,
      addOn = props.addOn;
  var image = details.image,
      title = details.title,
      calories = details.calories,
      desc = details.desc,
      nutritional = details.nutritional,
      likes = details.likes,
      initcost = details.initcost,
      min = details.MinimumQuantity,
      max = details.MaximumQuantity,
      isLoading = details.isLoading,
      ProductIdDb = details.ProductIdDb,
      ImageFilePath = details.ImageFilePath,
      DisplayName = details.DisplayName,
      _details$ListPrice = details.ListPrice,
      ListPrice = _details$ListPrice === void 0 ? "0.00" : _details$ListPrice,
      IsSpecialInstructonsEnabled = details.IsSpecialInstructonsEnabled,
      StoreProductId = details.StoreProductId,
      ProductChainId = details.ProductChainId,
      _details$DetailLink = details.DetailLink,
      DetailLink = _details$DetailLink === void 0 ? "" : _details$DetailLink;
  var _metadata$MetaDescrip = metadata.MetaDescription,
      MetaDescription = _metadata$MetaDescrip === void 0 ? null : _metadata$MetaDescrip,
      _metadata$MetaKeyword = metadata.MetaKeywords,
      MetaKeywords = _metadata$MetaKeyword === void 0 ? null : _metadata$MetaKeyword,
      _metadata$MetaTitle = metadata.MetaTitle,
      MetaTitle = _metadata$MetaTitle === void 0 ? null : _metadata$MetaTitle;
  var isCartLoading = props.isLoading;

  var _useState3 = useState(min || 1),
      _useState4 = _slicedToArray(_useState3, 2),
      counter = _useState4[0],
      setCounter = _useState4[1];

  var _useState5 = useState(overrideOptions === null || overrideOptions === void 0 ? void 0 : overrideOptions.defaultOptionName),
      _useState6 = _slicedToArray(_useState5, 2),
      defaultOptionName = _useState6[0],
      setDefaultName = _useState6[1];

  var _useState7 = useState(min),
      _useState8 = _slicedToArray(_useState7, 2),
      productmin = _useState8[0],
      setProductMin = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      optionGroups = _useState10[0],
      setOptionGroups = _useState10[1];

  var _useState11 = useState(""),
      _useState12 = _slicedToArray(_useState11, 2),
      instructions = _useState12[0],
      _setInstructions = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      dirty = _useState14[0],
      setDirty = _useState14[1];

  var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      sidesPresent = _useState16[0],
      setSidesPresent = _useState16[1];

  var _useState17 = useState([]),
      _useState18 = _slicedToArray(_useState17, 2),
      parentSideOptions = _useState18[0],
      setParentSidesOptions = _useState18[1];

  var _useState19 = useState([]),
      _useState20 = _slicedToArray(_useState19, 2),
      sideAmtArray = _useState20[0],
      setSideAmtArray = _useState20[1];

  var _useState21 = useState([]),
      _useState22 = _slicedToArray(_useState21, 2),
      currentSides = _useState22[0],
      setCurrentSides = _useState22[1];

  var _useState23 = useState(ListPrice),
      _useState24 = _slicedToArray(_useState23, 2),
      cost = _useState24[0],
      setCost = _useState24[1];

  var _useState25 = useState(false),
      _useState26 = _slicedToArray(_useState25, 2),
      isEditMode = _useState26[0],
      setEditMode = _useState26[1];

  var _useState27 = useState(false),
      _useState28 = _slicedToArray(_useState27, 2),
      errorExists = _useState28[0],
      setError = _useState28[1];

  var _useState29 = useState(location === null || location === void 0 ? void 0 : location.alternate_name),
      _useState30 = _slicedToArray(_useState29, 2),
      oloName = _useState30[0],
      setOloName = _useState30[1];

  var _useState31 = useState(location === null || location === void 0 ? void 0 : location.POSSystem),
      _useState32 = _slicedToArray(_useState31, 2),
      storeType = _useState32[0],
      setStoreType = _useState32[1];

  var _useState33 = useState(true),
      _useState34 = _slicedToArray(_useState33, 2),
      isDisabled = _useState34[0],
      setIsDisabled = _useState34[1];

  var _useState35 = useState(),
      _useState36 = _slicedToArray(_useState35, 2),
      selectedAddOn = _useState36[0],
      setSelectedAddon = _useState36[1];

  var addOnCost = useMemo(function () {
    var _addOn$AddOnProducts, _addOn$AddOnProducts$, _addOn$AddOnProducts$2;

    return (addOn === null || addOn === void 0 ? void 0 : (_addOn$AddOnProducts = addOn.AddOnProducts) === null || _addOn$AddOnProducts === void 0 ? void 0 : (_addOn$AddOnProducts$ = _addOn$AddOnProducts.find) === null || _addOn$AddOnProducts$ === void 0 ? void 0 : (_addOn$AddOnProducts$2 = _addOn$AddOnProducts$.call(_addOn$AddOnProducts, function (x) {
      return x.ProductChainId === selectedAddOn;
    })) === null || _addOn$AddOnProducts$2 === void 0 ? void 0 : _addOn$AddOnProducts$2.ListPrice) || 0;
  }, [selectedAddOn]);
  useEffect(function () {
    if (!details.isLoading) {
      var _props$details, _props$details$Displa, _props$menu, _props$menu$results$;

      var isIPM = props === null || props === void 0 ? void 0 : (_props$details = props.details) === null || _props$details === void 0 ? void 0 : (_props$details$Displa = _props$details.DisplayName) === null || _props$details$Displa === void 0 ? void 0 : _props$details$Displa.includes("Individually Packaged Meal");

      if (isIPM == true) {
        setCounter(8);
        setProductMin(8);
      }

      if ((overrideOptions === null || overrideOptions === void 0 ? void 0 : overrideOptions.defaultOptionName) != undefined) {
        setDefaultName(overrideOptions === null || overrideOptions === void 0 ? void 0 : overrideOptions.defaultOptionName);
      }

      ecommDetail({
        name: DisplayName,
        id: ProductChainId,
        price: ListPrice,
        detailLink: DetailLink || "",
        catalog: (props === null || props === void 0 ? void 0 : (_props$menu = props.menu) === null || _props$menu === void 0 ? void 0 : (_props$menu$results$ = _props$menu.results[0]) === null || _props$menu$results$ === void 0 ? void 0 : _props$menu$results$.Name) || ""
      });
      var options = defaultOptions === null || defaultOptions === void 0 ? void 0 : defaultOptions.options;
      UTIL.handleCost(optionGroups || [], 1, ListPrice, setCost);

      if (options && defaultOptions.storeProductId === StoreProductId && typeof StoreProductId !== "undefined") {
        handleOptionGroups(options[0]);
      }
    }
  }, [details]);
  useEffect(function () {
    handleMapSides();
  }, [currentSides]);
  useEffect(function () {
    if (addTo) {
      setCounter(min || 1);
      setOptionGroups([]);

      _setInstructions("");

      setDirty(false);
      setSidesPresent(false);
      setParentSidesOptions([]);
      setSideAmtArray([]);
      setCurrentSides([]);
      setCost(ListPrice);
      setEditMode(false);
      setError(false);
      setOloName(location === null || location === void 0 ? void 0 : location.alternate_name);
    }
  }, [addTo]);
  useEffect(function () {
    if (location === null || location === void 0 ? void 0 : location.POSSystem) {
      setStoreType(location === null || location === void 0 ? void 0 : location.POSSystem);
    }
  }, [location]);
  useEffect(function () {
    var _editCartItem$Product;

    if (typeof StoreProductId === "undefined") {
      return setEditMode(false);
    }

    if ((editCartItem === null || editCartItem === void 0 ? void 0 : (_editCartItem$Product = editCartItem.Product) === null || _editCartItem$Product === void 0 ? void 0 : _editCartItem$Product.StoreProductId) === StoreProductId) {
      setEditMode(true);
      setCounter(editCartItem.Quantity);
      var lineOptions = UTIL.toCamel(editCartItem.LineOptions);
      setCost(editCartItem.LineCost / editCartItem.Quantity);

      _setInstructions(editCartItem.SpecialInstruction || "");

      return setOptionGroups(lineOptions || []);
    }

    setEditMode(false);
  }, [editCartItem, StoreProductId]);
  useEffect(function () {
    allSides = [];
  }, []);
  var counterValues = {
    min: parseInt(productmin),
    max: max === "0" ? 99 : parseInt(max)
  };

  var handleOptionGroups = function handleOptionGroups(newUpdate) {
    var updatedOptions = UTIL.filterArrayAdd(optionGroups, newUpdate, "optionGroupId");
    UTIL.handleCost(updatedOptions, 1, ListPrice, setCost);
    updatedOptions = updatedOptions.filter(function (item) {
      //console.log('Selected options: ',item.selectedOptions.length)
      return item.selectedOptions.length;
    });
    setOptionGroups(updatedOptions);
    return setDirty(!dirty);
  };

  var handleMapSides = function handleMapSides() {
    var sides = [];
    var rightNumberOfSides = sideAmtArray.map(function (el, i) {
      return currentSides[i];
    }).filter(function (el) {
      return el;
    });
    rightNumberOfSides.forEach(function (side) {
      for (var i = 0; i < side.quantity; i++) {
        sides.push(side);
      }
    });
    var options = sides.map(function (side, index) {
      var _allSides$index$produ, _allSides$index$produ2, _allSides$index$produ3, _allSides$index$produ4;

      var sidePositionInfoIndex = allSides[index].productModifierOptions.findIndex(function (element) {
        return side.optionName.toLowerCase() === (element === null || element === void 0 ? void 0 : element.optionName.toLowerCase());
      });
      return UTIL.makeSelected((_allSides$index$produ = allSides[index].productModifierOptions[sidePositionInfoIndex]) === null || _allSides$index$produ === void 0 ? void 0 : _allSides$index$produ.chainId, (_allSides$index$produ2 = allSides[index].productModifierOptions[sidePositionInfoIndex]) === null || _allSides$index$produ2 === void 0 ? void 0 : _allSides$index$produ2.optionId, (_allSides$index$produ3 = allSides[index].productModifierOptions[sidePositionInfoIndex]) === null || _allSides$index$produ3 === void 0 ? void 0 : _allSides$index$produ3.cost, (_allSides$index$produ4 = allSides[index].productModifierOptions[sidePositionInfoIndex]) === null || _allSides$index$produ4 === void 0 ? void 0 : _allSides$index$produ4.optionName);
    });
    var sideGroups = sideAmtArray.map(function (side, index) {
      return _objectSpread(_objectSpread({}, side), {}, {
        optionGroupName: "Side ".concat(index + 1),
        selectedOptions: [options[index]]
      });
    });
    sideGroups.forEach(function (side) {
      handleOptionGroups(side);
    });
    return sideGroups;
  };

  var errorClick = function errorClick() {
    var data = {
      gtm: {
        uniqueEventId: 97,
        elementId: "detail-customizeerror"
      },
      event: 'gtm.click'
    };
    gaTracker(data);
  };

  var handleSelectedOptions = function handleSelectedOptions(selectedOptions) {
    if (selectedOptions && typeof selectedOptions !== undefined && selectedOptions.length) {
      return selectedOptions[0];
    }

    return null;
  };

  var formId = document.querySelector("#cb-detail-form");

  var handleSubmit = function handleSubmit(e) {
    e.persist();
    e.preventDefault();
    var mappedSelections = Array.isArray(optionGroups) ? optionGroups.map(function (el) {
      return el.selectedOptions[0];
    }) : [];
    var optionsNotMissing = Boolean(mappedSelections.reduce(function (el, acc) {
      return Boolean(acc) && Boolean(el);
    }, true));

    if (e.currentTarget.checkValidity() && optionsNotMissing) {
      sendSubmit();
    } else {
      setError(true);
    }
  };

  var sendSubmit = function sendSubmit() {
    var _props$menu2, _props$menu2$results$;

    var groups = Array.isArray(optionGroups) ? optionGroups : [];
    var formInfo = {
      "options": _toConsumableArray(groups),
      "StoreProductId": StoreProductId,
      "ProductChainId": ProductChainId,
      "displayName": DisplayName,
      "quantity": counter,
      "specialInstruction": instructions || "",
      "recipient": "",
      "imageUrl": ImageFilePath,
      "total": cost
    };

    if (selectedAddOn) {
      var _addOn$AddOnProducts2, _addOn$AddOnProducts3, _addOn$AddOnProducts4;

      formInfo.AddOnProductRequest = {
        ProductChainId: selectedAddOn,
        StoreProductId: (_addOn$AddOnProducts2 = addOn.AddOnProducts) === null || _addOn$AddOnProducts2 === void 0 ? void 0 : (_addOn$AddOnProducts3 = _addOn$AddOnProducts2.find) === null || _addOn$AddOnProducts3 === void 0 ? void 0 : (_addOn$AddOnProducts4 = _addOn$AddOnProducts3.call(_addOn$AddOnProducts2, function (x) {
          return x.ProductChainId === selectedAddOn;
        })) === null || _addOn$AddOnProducts4 === void 0 ? void 0 : _addOn$AddOnProducts4.StoreProductId
      };
    }

    if (isEditMode) {
      ecommEdit({
        name: DisplayName,
        id: ProductChainId,
        price: cost,
        detailLink: DetailLink,
        quantity: counter
      });
      return updateCartLine(editCartItem.Id, _toConsumableArray(groups), counter, formInfo, true, selectedAddOn ? formInfo.AddOnProductRequest : null);
    }

    ecommAdd({
      name: DisplayName,
      id: ProductChainId,
      price: cost,
      detailLink: DetailLink,
      quantity: counter,
      catalog: (props === null || props === void 0 ? void 0 : (_props$menu2 = props.menu) === null || _props$menu2 === void 0 ? void 0 : (_props$menu2$results$ = _props$menu2.results[0]) === null || _props$menu2$results$ === void 0 ? void 0 : _props$menu2$results$.Name) || ""
    });
    return postItem(formInfo);
  };

  var handleSidesPresent = function handleSidesPresent(showSides, sideOptions, newData) {
    var _sideOptions$, _sideOptions$2, _sideOptions$3, _sideOptions$4, _sideOptions$5;

    var parentOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var singleSideSelectionObject = (_sideOptions$ = sideOptions[0]) === null || _sideOptions$ === void 0 ? void 0 : _sideOptions$.productModifierOptionsGroup[0];
    var newSideAmtArray = parentOptions.map(function (el) {
      var _el$productModifierOp, _el$productModifierOp2, _el$productModifierOp3, _el$productModifierOp4;

      return {
        optionGroupId: el === null || el === void 0 ? void 0 : (_el$productModifierOp = el.productModifierOptions[0]) === null || _el$productModifierOp === void 0 ? void 0 : (_el$productModifierOp2 = _el$productModifierOp.productModifierOptionsGroup[0]) === null || _el$productModifierOp2 === void 0 ? void 0 : _el$productModifierOp2.optionGroupId,
        optionGroupChainId: el === null || el === void 0 ? void 0 : (_el$productModifierOp3 = el.productModifierOptions[0]) === null || _el$productModifierOp3 === void 0 ? void 0 : (_el$productModifierOp4 = _el$productModifierOp3.productModifierOptionsGroup[0]) === null || _el$productModifierOp4 === void 0 ? void 0 : _el$productModifierOp4.chainId
      };
    });
    var toAddToMods = {
      optionGroupChainId: newData.optionGroupChainId,
      optionGroupId: newData.optionGroupId,
      optionGroupName: (_sideOptions$2 = sideOptions[0]) === null || _sideOptions$2 === void 0 ? void 0 : _sideOptions$2.optionName,
      selectedOptions: [{
        cost: 0,
        optionChainId: (_sideOptions$3 = sideOptions[0]) === null || _sideOptions$3 === void 0 ? void 0 : _sideOptions$3.chainId,
        optionId: (_sideOptions$4 = sideOptions[0]) === null || _sideOptions$4 === void 0 ? void 0 : _sideOptions$4.optionId,
        optionName: (_sideOptions$5 = sideOptions[0]) === null || _sideOptions$5 === void 0 ? void 0 : _sideOptions$5.optionName
      }]
    }; //used for sides later

    allSides = UTIL.filterArrayAdd(allSides, singleSideSelectionObject, "description");
    var childOptions = singleSideSelectionObject.productModifierOptions.map(function (option) {
      return Array.isArray(option.productModifierOptionsGroup) && option.productModifierOptionsGroup.map(function (newOption) {
        return _objectSpread(_objectSpread({}, newOption), {}, {
          parentChainId: option.chainId,
          parentOptionGroupId: option.optionGroupId
        });
      });
    });
    childSideOptions = [].concat(_toConsumableArray(childSideOptions), _toConsumableArray(childOptions.filter(Boolean)));
    handleOptionGroups(toAddToMods);
    setSidesPresent(showSides);
    setParentSidesOptions(_toConsumableArray(sideOptions));
    setSideAmtArray(newSideAmtArray);
  };

  var handleCounter = function handleCounter(newValue) {
    UTIL.handleCost(optionGroups, 1, ListPrice, setCost);
    return setCounter(newValue);
  };

  var calculatedCost = ((parseFloat(cost) + addOnCost) * counter).toFixed(2);
  var id = uniqueId();
  var sideId = uniqueId();
  useEffect(function () {
    var _editCartItem$AddOnPr;

    if (editCartItem === null || editCartItem === void 0 ? void 0 : (_editCartItem$AddOnPr = editCartItem.AddOnProductDetails) === null || _editCartItem$AddOnPr === void 0 ? void 0 : _editCartItem$AddOnPr.ProductId) {
      setSelectedAddon(editCartItem.AddOnProductDetails.ProductId);
    }
  }, [editCartItem === null || editCartItem === void 0 ? void 0 : (_editCartItem$AddOnPr2 = editCartItem.AddOnProductDetails) === null || _editCartItem$AddOnPr2 === void 0 ? void 0 : _editCartItem$AddOnPr2.ProductId]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MetaTags, null, Boolean(MetaTitle) && /*#__PURE__*/React.createElement("title", null, MetaTitle), Boolean(MetaDescription) && /*#__PURE__*/React.createElement("meta", {
    name: "description",
    content: MetaDescription
  }), Boolean(MetaKeywords) && /*#__PURE__*/React.createElement("meta", {
    property: "keywords",
    content: MetaKeywords
  }), "s"), isLoading && /*#__PURE__*/React.createElement("div", {
    className: "cb-l-container-wrapper--space"
  }, /*#__PURE__*/React.createElement(Loading, {
    isLoading: isLoading
  })), !isLoading && /*#__PURE__*/React.createElement(Wrapper, {
    layout: layout
  }, /*#__PURE__*/React.createElement(Form, {
    noValidate: true,
    onSubmit: handleSubmit,
    id: "cb-detail-form"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-l-container-wrapper--edge"
  }, /*#__PURE__*/React.createElement(Image, {
    media: image,
    className: "cb-menu-detail__image"
  })), /*#__PURE__*/React.createElement("div", {
    className: "cb-l-container-wrapper--space"
  }, /*#__PURE__*/React.createElement(ItemHeader, {
    title: title,
    calories: calories,
    nutritional: nutritional,
    desc: desc
  }), sidesPresent && /*#__PURE__*/React.createElement("div", {
    className: "cb-menu-detail__customization",
    id: "cb-menu-detail__customization-".concat(sideId)
  }, /*#__PURE__*/React.createElement(HandleSides, {
    sidesOptions: parentSideOptions,
    availableAmount: sideAmtArray.length,
    currentSides: currentSides,
    mods: optionGroups,
    index: modifications.length,
    setMods: handleOptionGroups,
    setCurrentSides: setCurrentSides,
    childSideOptions: childSideOptions,
    isEditMode: isEditMode,
    editOptions: editCartItem === null || editCartItem === void 0 ? void 0 : editCartItem.LineOptions
  })), /*#__PURE__*/React.createElement("div", {
    className: "cb-menu-detail__customization",
    id: "cb-menu-detail__customization-".concat(id)
  }, Array.isArray(modifications) && modifications.map(function (custom, index) {
    // console.log('test custom: ', custom);
    // optionGroups.indexOf(custom.optionGroupId) === -1 ? optionGroups.push(custom.optionGroupId) : console.log('');
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Customization, {
      defaultOptionName: defaultOptionName,
      customObj: custom,
      parentOptions: modifications,
      key: "modificationDetail_" + index,
      index: index,
      mods: optionGroups,
      setMods: handleOptionGroups,
      handleSidesPresent: handleSidesPresent,
      option: defaultOptions,
      isEditMode: isEditMode,
      editOptions: editCartItem === null || editCartItem === void 0 ? void 0 : editCartItem.LineOptions,
      addOn: addOn
    }));
  }), !!(addOn === null || addOn === void 0 ? void 0 : (_addOn$AddOnProducts5 = addOn.AddOnProducts) === null || _addOn$AddOnProducts5 === void 0 ? void 0 : _addOn$AddOnProducts5.length) && /*#__PURE__*/React.createElement(CustomizationAddOn, {
    onChange: setSelectedAddon,
    header: addOn === null || addOn === void 0 ? void 0 : addOn.Header,
    headline: addOn === null || addOn === void 0 ? void 0 : addOn.Headline,
    options: addOn === null || addOn === void 0 ? void 0 : addOn.AddOnProducts,
    value: selectedAddOn
  })), IsSpecialInstructonsEnabled && storeType === 'MAX' && /*#__PURE__*/React.createElement(SpecialInstructions, {
    instructions: instructions,
    setInstructions: function setInstructions(e) {
      return _setInstructions(e);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement(RichText, {
    field: Disclaimer
  }))), /*#__PURE__*/React.createElement(StickyCta, {
    cost: cost + addOnCost,
    calculatedCost: calculatedCost,
    addToOrderClick: addToOrderClick,
    modifications: modifications,
    errorClick: errorClick,
    setError: setError,
    counter: counter,
    handleCounter: handleCounter,
    counterValues: counterValues,
    errorExists: errorExists,
    formId: formId,
    optionGroups: optionGroups,
    isLoading: isCartLoading
  }))));
};

var ItemHeader = function ItemHeader(_ref) {
  var title = _ref.title,
      calories = _ref.calories,
      nutritional = _ref.nutritional,
      desc = _ref.desc;
  return /*#__PURE__*/React.createElement("div", {
    id: "cb-menu-detail__itemheader",
    className: "cb-menu-detail__itemheader"
  }, /*#__PURE__*/React.createElement(Heading, {
    level: 1,
    field: title,
    className: "cb-menu-detail__title"
  }), /*#__PURE__*/React.createElement(Heading, {
    level: 3,
    field: calories,
    className: "cb-menu-detail__subtitle"
  }), /*#__PURE__*/React.createElement(Heading, {
    level: 2,
    field: desc,
    className: "cb-menu-detail__content"
  }));
};

export var SpecialInstructions = function SpecialInstructions(_ref2) {
  var _ref2$instructions = _ref2.instructions,
      instructions = _ref2$instructions === void 0 ? "" : _ref2$instructions,
      _ref2$setInstructions = _ref2.setInstructions,
      setInstructions = _ref2$setInstructions === void 0 ? function () {
    return "";
  } : _ref2$setInstructions;

  var _useState37 = useState(instructions !== "" ? true : false),
      _useState38 = _slicedToArray(_useState37, 2),
      active = _useState38[0],
      setActive = _useState38[1];

  var maxCharacters = 35;

  var handleClick = function handleClick() {
    setActive(!active);
  };

  var handleChange = function handleChange(e) {
    if (e.target.value.length > maxCharacters) {
      return;
    }

    return setInstructions(e.target.value);
  };

  useEffect(function () {
    setActive(instructions !== "" ? true : false);
  }, [instructions]);
  useEffect(function () {
    if (active) {
      return setInstructions(instructions);
    }

    console.log('Set instructions: ', instructions, active);
    return setInstructions("");
  }, [active]);
  return /*#__PURE__*/React.createElement(SeparatedInstructions, {
    onClick: handleClick,
    active: active,
    copy: "Special Instructions",
    instructions: instructions
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement("label", {
    className: "cb-form__label is-active"
  }, "Special Instructions"), /*#__PURE__*/React.createElement("input", {
    value: instructions,
    onChange: handleChange,
    className: "cb-form__input--full cb-form__input form-control"
  })), /*#__PURE__*/React.createElement("p", {
    className: "cb-special-instructions__remaining"
  }, "Remaining characters: ", maxCharacters - instructions.length), /*#__PURE__*/React.createElement("p", {
    className: "cb-special-instructions__disclaimer"
  }, "*For food allergies or request that might incur additional costs, please call to place your order"));
};
export var SeparatedInstructions = function SeparatedInstructions(_ref3) {
  var onClick = _ref3.onClick,
      active = _ref3.active,
      copy = _ref3.copy,
      children = _ref3.children,
      instructions = _ref3.instructions;
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-special-instructions"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onClick,
    className: "".concat(active ? "isActive" : "")
  }, /*#__PURE__*/React.createElement("i", {
    className: "".concat(active ? "isActive" : "")
  }), active ? "Delete" : "Add", " ", copy), /*#__PURE__*/React.createElement("div", {
    className: "cb-special-instructions__lower ".concat(active ? "" : "d-none")
  }, children));
};